<template>
  <div class="columns is-multiline">
    <div class="column is-7">
      <div class="box">
        <admin-box-item title="게시물 맞춤 DB 등록" subtitle="등록한 DB 판넬은 추가한 게시판의 등록페이지에 포함되어 노출됩니다. 해당 DB의 프론트 노출을 원하시면 추가 개발을 통해 노출 가능합니다.">
          <div class="columns is-multiline">
            <div class="column is-full">
              <admin-form-item label="맞춤DB 이름*" tip="맞춤 DB 이름은 필수 입력사항 입니다.">
                <input class="input"
                       :value="param.name"
                       @input="e =>setDbName(e)"
                       type="text" maxlength="50">
              </admin-form-item>
            </div>

            <div class="column is-full">
              <admin-form-item label="description">
                <textarea class="textarea"
                          rows="10"
                          cols="10"
                          :value="param.description"
                          @input="e => param.description = e.target.value"></textarea>
              </admin-form-item>
            </div>

            <div class="column is-full">
              <admin-form-item label="label">
                <input class="input"
                       :value="param.label"
                       @input="e => param.label = e.target.value"
                       type="text" maxlength="50">
              </admin-form-item>
            </div>

            <div class="column is-full">
              <admin-form-item label="placeholder">
                <input class="input"
                       :value="param.placeholder"
                       @input="e => param.placeholder = e.target.value">
              </admin-form-item>
            </div>

            <div class="column is-full" v-if="param.format==='CRange' || param.format==='CFloatRange'">
              <admin-form-item label="단위">
                <input class="input"
                       :value="param.unit"
                       placeholder="단위를 입력하세요."
                       @input="e=> param.unit = e.target.value">
              </admin-form-item>
            </div>

            <div class="column is-full">
              <admin-form-item label="맞춤DB 타입*">
                <lp-radio @onSelect="clickParamType"
                          value_name="value"
                          label_name="label"
                          ref="radio_db_type"
                          :val.sync="param.format" :data="param_type_arr" type="small"></lp-radio>
              </admin-form-item>
            </div>

            <!-- 체크박스 선택형 -->
            <div class="column is-full" v-if="param.format==='CCheckboxGroup' || param.format==='CRadiobuttonGroup'">
              <admin-form-item>
                <div>
                  <div class="columns is-multiline">
                    <div class="column flex">
                      <div style="color: #363636; display: block; line-height: 28px; font-weight: 700; margin-right: 8px; font-size: 0.9rem">선택지</div>
                      <button class="button is-primary" @click="addItem">추가하기</button>
                    </div>
                  </div>
                  <draggable class="choice-items">
                    <div v-for="(item, idx) in param.choice_items" :key="`item-${idx}`"
                      class="columns is-multiline">
                      <div class="column is-full">
                        <admin-form-item>
                          <div class="flex">
                            <div class="unselect" style="padding: 4px 4px 0 0">
                              <i class="material-icons">drag_indicator</i>
                            </div>
                            <div>
                              <input class="input"
                                     :value="item.name"
                                     @input="e => item.name = e.target.value"
                                     type="text" maxlength="30">
                            </div>
                            <div @click="delChoiceItem(item.id, idx)" style="cursor: pointer">
                              <i class="material-icons" style="line-height: 32px">close</i>
                            </div>
                          </div>
                        </admin-form-item>
                      </div>
                    </div>
                  </draggable>
                </div>
              </admin-form-item>
            </div>

            <!-- 직선형 스탭 -->
            <div class="column is-full" v-if="param.format==='CLinear'">
              <admin-form-item>
                <div class="flex">
                  <span class="select">
                    <select v-model="param.options.range.min.val"
                      @change="e => param.options.range.min.val = e.target.value">
                      <option value="" disabled selected>선택</option>
                      <option :value="item.value"
                        v-for="item in options.linear.min" :key="item.label"
                        >{{ item.label }}</option>
                    </select>
                  </span>

                  <div class="wave"> ~ </div>

                  <span class="select">
                    <select v-model="param.options.range.max.val"
                      @change="e => param.options.range.max.val=e.target.value">
                      <option value="" disabled selected>선택</option>
                      <option :value="item.value"
                        v-for="item in options.linear.max" :key="item.label"
                        >{{ item.label }}</option>
                    </select>
                  </span>
                </div>
              </admin-form-item>

              <admin-form-item>
                <div class="flex">
                  <div class="range-label-title">{{ param.options.range.min.val }}</div>
                  <input class="input"
                         :value="param.options.range.min.label"
                         @input="e => param.options.range.min.label = e.target.value">
                </div>
                <div class="flex">
                  <div class="range-label-title">{{ param.options.range.max.val }}</div>
                  <input class="input"
                         :value="param.options.range.max.label"
                         @input="e => param.options.range.max.label = e.target.value">
                </div>
              </admin-form-item>
            </div>

            <!-- 숫자 레인지 -->
            <!--<div class="column is-full" v-if="param.format==='CRange' || param.format==='CFloatRange'">
              <div class="columns is-multiline">
                <div class="column">
                  <admin-form-item label="최소">
                    <input class="input"
                           :value="param.options.min"
                           @input="e => param.options.min = e.target.value">
                  </admin-form-item>
                </div>
                <div class="column">
                  <admin-form-item label="최대">
                    <input class="input"
                           :value="param.options.max"
                           @input="e => param.options.max = e.target.value">
                  </admin-form-item>
                </div>
                <div class="column">
                  <admin-form-item label="단위">
                    <input class="input"
                           :value="param.options.unit"
                           @input="e => param.options.unit = e.target.value">
                  </admin-form-item>
                </div>
              </div>
            </div>-->

          </div>
        </admin-box-item>
      </div>
      <div class="btn-group-justify-end">
        <button class="button is-primary" @click="saveData">저장하기</button>
      </div>
    </div>
  </div>
</template>

<script>
  import draggable from 'vuedraggable'
  import LpInputText from "../../module/common/LpInputText";
  import LpRadio from "../../module/common/LpRadio";
  import AdminBoxItem from "../../module/admin/AdminBoxItem";
  import LpDropdown from "../../module/common/LpDropdown";
  import LpCheckBool from "../../module/common/LpCheckBool";
  import AdminFormItem from "../../module/admin/AdminFormItem";
  import ParamMixin from "@/mixins/ParamMixin";
  import CreateMixin from "@/mixins/CreateMixin"

  export default {
    mixins: [
      ParamMixin,
      CreateMixin
    ],
    components: {
      AdminFormItem,
      draggable,
      LpCheckBool,
      LpDropdown,
      AdminBoxItem,
      LpRadio,
      LpInputText

    },
    created() {
      this.getData();
    },
    methods: {
      // 선택지 아이템 삭제
      delChoiceItem(id, index){
        if(id) {
          this.$axios.delete(this.getUrl('board/post/paramitem/' + id)).then(res=>{
            if(res.status===200) {
              removeIndex(this.param.choice_items, index);
            }
          });
        }
        else {
          removeIndex(this.param.choice_items, index);
        }
      },
      setDbName(e){
        this.param.name = e.target.value;
        this.param.field = e.target.value;
      },
      addItem(){
        let item = {
          name: 'item1'
        }
        this.param.choice_items.push(item);
      },
      saveData(){
        let err = '';
        if(this.param.name==='') err = '맞춤 DB 이름을 입력하세요.';
        else if(this.param.format==='') err = '파라미터 타입을 선택하세요.';
        else if(this.param.param_type===3){
          for(let i=0; i<this.param.choice_items.length; i++){
            if(this.param.choice_items[i].name===''){
              err = '선택형 아이템 이름을 입력하세요.';
              break;
            }
          }
        }

        if(err) {
          this.toast(err);
          return;
        }

        if(this.$route.query.id){
          this.$axios.patch(this.getUrl('board/post/param/'+this.$route.query.id), this.param).then(res=>{
            if(res.status===200){
              this.toast('저장되었습니다');
              if(this.$store.getters.mode==='admin'){
                this.$router.replace(this.getPath('post/param'));
              }
              else{
                this.$router.replace('post/param');
              }
            }
          })
        }
        else{
          this.$axios.post(this.getUrl('board/post/param'), this.param).then(res=>{
            if(res.status===200){
              this.toast('저장되었습니다');
              if(this.$store.getters.mode==='admin'){
                this.$router.replace(this.getPath('post/param'));
              }
              else{
                this.$router.replace('post/param');
              }
            }
          })
        }
      },
      getData(){
        if(this.$route.query.id){
          this.$axios.get(this.getUrl('board/post/param/'+this.$route.query.id)).then(res=>{
            if(res.data.param_type===6) {
              this.getLinearOptions();
            }
            this.param = res.data;
          })
        }
      }
    }
  }
</script>

<style lang="styl" type="stylus" scoped>
  //@import '~assets/css/lp_main'

  .choice-items
    height 320px
    overflow-y scroll
    overflow-x hidden
    margin 20px 0
    border 1px solid #ddd
    padding 16px

  .box-param
    box-sizing border-box
    padding 20px
    background-color white
    overflow-y auto
    max-height 500px

  .lp-bg-sub-in-title
    line-height 2rem
</style>
